import React from 'react'

const LastestProject = () => {
  return (
    <>
<section className="latest-project-area">
  <div className="container-fluid">
    <div className="container">
      <div className="sec-title pull-left">
        <h2>Latest <span>Projects</span></h2>
        <span className="decor" />
      </div>   
   
    </div>
    <div className="row project-content masonary-layout filter-layout">
      {/*Start single project*/}
      <div className="col-md-3 col-sm-6 col-xs-12 filter-item corporate residential industrial">
        <div className="single-project-item">
          <div className="img-holder">
            <img src="images/project/lat-pj-1.jpg" alt="Awesome Image" />
            <div className="overlay">
              <div className="box">
                <div className="content">
                  <a ><h3>Modern Living Room</h3></a>
                  <p style={{textAlign:"center"}}>Residential</p>
                  <div className="icon-holder">
                    <a to="images/project/lat-pj-1.jpg" data-rel="prettyPhoto" title="Interrio Project"><i className="fa fa-camera" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>   
        </div>
      </div>
      {/*End single project*/}
      {/*Start single project*/}
      <div className="col-md-3 col-sm-6 col-xs-12 filter-item industrial corporate">
        <div className="single-project-item">
          <div className="img-holder">
            <img src="images/project/lat-pj-2.jpg" alt="Awesome Image" />
            <div className="overlay">
              <div className="box">
                <div className="content">
                  <a><h3>Modern Living Room</h3></a>
                  <p style={{textAlign:"center"}}>Residential</p>
                  <div className="icon-holder">
                    <a to="images/project/lat-pj-2.jpg" data-rel="prettyPhoto" title="Interrio Project"><i className="fa fa-camera" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>   
        </div>
      </div>
      {/*End single project*/}
      {/*Start single project*/}
      <div className="col-md-3 col-sm-6 col-xs-12 filter-item corporate residential restaurant">
        <div className="single-project-item">
          <div className="img-holder">
            <img src="images/project/lat-pj-3.jpg" alt="Awesome Image" />
            <div className="overlay">
              <div className="box">
                <div className="content">
                  <a><h3>Modern Living Room</h3></a>
                  <p style={{textAlign:"center"}}>Residential</p>
                  <div className="icon-holder">
                    <a to="images/project/lat-pj-3.jpg" data-rel="prettyPhoto" title="Interrio Project"><i className="fa fa-camera" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>   
        </div>
      </div>
      {/*End single project*/}
      {/*Start single project*/}
      <div className="col-md-3 col-sm-6 col-xs-12 filter-item corporate residential industrial">
        <div className="single-project-item">
          <div className="img-holder">
            <img src="images/project/lat-pj-4.jpg" alt="Awesome Image" />
            <div className="overlay">
              <div className="box">
                <div className="content">
                  <a><h3>Modern Living Room</h3></a>
                  <p style={{textAlign:"center"}}>Residential</p>
                  <div className="icon-holder">
                    <a to="images/project/lat-pj-4.jpg" data-rel="prettyPhoto" title="Interrio Project"><i className="fa fa-camera" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>   
        </div>
      </div>
      {/*End single project*/}
      {/*Start single project*/}
      <div className="col-md-3 col-sm-6 col-xs-12 filter-item residential corporate industrial">
        <div className="single-project-item">
          <div className="img-holder">
            <img src="images/project/lat-pj-5.jpg" alt="Awesome Image" />
            <div className="overlay">
              <div className="box">
                <div className="content">
                  <a><h3>Modern Living Room</h3></a>
                  <p style={{textAlign:"center"}}>Residential</p>
                  <div className="icon-holder">
                    <a to="images/project/lat-pj-5.jpg" data-rel="prettyPhoto" title="Interrio Project"><i className="fa fa-camera" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>   
        </div>
      </div>
      {/*End single project*/}
      {/*Start single project*/}
      <div className="col-md-3 col-sm-6 col-xs-12 filter-item residential industrial restaurant">
        <div className="single-project-item">
          <div className="img-holder">
            <img src="images/project/lat-pj-6.jpg" alt="Awesome Image" />
            <div className="overlay">
              <div className="box">
                <div className="content">
                  <a><h3>Modern Living Room</h3></a>
                  <p style={{textAlign:"center"}}>Residential</p>
                  <div className="icon-holder">
                    <a to="images/project/lat-pj-6.jpg" data-rel="prettyPhoto" title="Interrio Project"><i className="fa fa-camera" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>   
        </div>
      </div>
      {/*End single project*/}
      {/*Start single project*/}
      <div className="col-md-3 col-sm-6 col-xs-12 filter-item residential corporate restaurant">
        <div className="single-project-item">
          <div className="img-holder">
            <img src="images/project/lat-pj-7.jpg" alt="Awesome Image" />
            <div className="overlay">
              <div className="box">
                <div className="content">
                  <a><h3>Modern Living Room</h3></a>
                  <p style={{textAlign:"center"}}>Residential</p>
                  <div className="icon-holder">
                    <a to="images/project/lat-pj-7.jpg" data-rel="prettyPhoto" title="Interrio Project"><i className="fa fa-camera" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>   
        </div>
      </div>
      {/*End single project*/}
      {/*Start single project*/}
      <div className="col-md-3 col-sm-6 col-xs-12 filter-item residential industrial">
        <div className="single-project-item">
          <div className="img-holder">
            <img src="images/project/lat-pj-8.jpg" alt="Awesome Image" />
            <div className="overlay">
              <div className="box">
                <div className="content">
                  <a><h3>Modern Living Room</h3></a>
                  <p style={{textAlign:"center"}}>Residential</p>
                  <div className="icon-holder">
                    <a to="images/project/lat-pj-8.jpg" data-rel="prettyPhoto" title="Interrio Project"><i className="fa fa-camera" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>   
        </div>
      </div>
      {/*End single project*/}
    </div>     
  </div>
</section>

    </>
  )
}

export default LastestProject